<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-15 21:59:27
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-06-24 15:47:16
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="title-wrap">
        <h2 class="title">
          <span class="txt">流转合同详情</span>
        </h2>
      </div>
      <el-table :data="info" border style="width: 100%">
        <el-table-column
          prop="contractNum"
          label="合同编号"
          min-width="18%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="villageName"
          label="所属村"
          min-width="32%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          label="合同期限"
          min-width="35%"
          align="center"
          :resizable="false"
        >
          <template slot-scope="scope">{{ scope.row | formatDate }}</template>
        </el-table-column>
        <el-table-column
          prop="contractArea"
          label="流转面积"
          min-width="15%"
          align="center"
          :resizable="false"
        >
          <template slot-scope="scope">{{ scope.row.contractArea }}亩</template>
        </el-table-column>
        <el-table-column
          prop="statusFlagName"
          label="合同状态"
          min-width="15%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
      </el-table>
      <el-tabs v-model="activeName">
        <el-tab-pane label="合同地块" name="first">
          <ContractLand
            v-if="isRequest"
            :contractId="id"
            :contractType="contractType"
          ></ContractLand>
        </el-tab-pane>
        <el-tab-pane label="合同订单" name="second">
          <ContractOrder v-if="isRequest" :contractId="id"></ContractOrder>
        </el-tab-pane>
        <el-tab-pane label="流转合同" name="third">
          <OriginalFile v-if="isRequest" :type="2" :bizId="id"></OriginalFile>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-main>
</template>

<script>
import OriginalFile from "@/components/OriginalFile";
import ContractOrder from "./components/ContractOrder";
import ContractLand from "./components/ContractLand";
export default {
  name: "ContractDetail",
  components: {
    OriginalFile,
    ContractOrder,
    ContractLand,
  },
  data() {
    return {
      id: "",
      contractType: "transfer",
      detail: {},
      info: [],
      activeName: "first",
      isRequest: false,
    };
  },
  filters: {
    formatDate(value) {
      let result = `${value.allottedTimeBegin}~${value.allottedTimeEnd}`;
      return result;
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getContractDetail();
  },
  methods: {
    /**
     * @descripttion: 获取合同详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getContractDetail() {
      this.$http.contract.getContractDetail({ id: this.id }).then((res) => {
        this.isRequest = true;
        this.detail = res.data;
        this.info = [res.data];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
@import "@/styles/common.scss";
.main {
  padding-top: 0 !important;
  .title-wrap {
    @include plate-title-mutil;
    height: 55px;
    border-bottom: 1px solid #e9ebee;
  }
  .el-table {
    margin-top: 16px;
  }
}
</style>
